export const ID_FILTER_SEARCH = "search";
export const ID_FILTER_REPORT_NAME= "name";
export const ID_FILTER_REPORT_CREATIONDATEFROM ="creation-date-from";
export const ID_FILTER_REPORT_CREATIONDATETO ="creation-date-to";
export const ID_FILTER_PRINTOUT_REPORTNAME = "report-name";
export const ID_FILTER_PRINTOUT_MSCODE = "ms-code";
export const ID_FILTER_PRINTOUT_MSNAME ='ms-name';
export const ID_FILTER_PRINTOUT_STATUS = "status";
export const ID_FILTER_PRINTOUT_TYPE = "type";
export const ID_FILTER_PRINTOUT_CREATIONDATEFROM ="creation-date-from";
export const ID_FILTER_PRINTOUT_CREATIONDATETO ="creation-date-to";
export const ID_FILTER_PRINTOUT_SENTDATEFROM ="sent-date-from";
export const ID_FILTER_PRINTOUT_SENTDATETO ="sent-date-to";
export const ID_FILTER_PRINTOUT_INVOICE_NUMBER ="invoice-number";
export const ID_FILTER_PRINTOUT_SAP_INVOICE_NUMBER ="sap-invoice-number";

export const ID_FILTER_PRINTOUT_CODE_SAP = "code-sap";
export const ID_FILTER_PRINTOUT_CODE_SAP_M = "code-sap-mandatory";
export const ID_FILTER_PRINTOUT_NAME_M = "name-mandatory";
export const ID_FILTER_PRINTOUT_EMAIL_M = "email-mandatory";
export const ID_FILTER_PRINTOUT_PROPERTY = "property";
export const ID_FILTER_PRINTOUT_CLUSTER = "cluster";
export const ID_FILTER_PRINTOUT_TOTAL_FROM = "total-from";
export const ID_FILTER_PRINTOUT_TOTAL_TO = "total-to";
export const ID_FILTER_PRINTOUT_PUBLISHEDDATEFROM = "published-date-from";
export const ID_FILTER_PRINTOUT_PUBLISHEDDATETO = "published-date-to";
export const ID_FILTER_LEGAL_ENTITIES = "legal-entities";
export const ID_FILTER_DEALERS = "dealers";

export const msReportDefaultValues = {
    reportDateFrom: null,
    reportDateTo: null
}

export const msPrintoutDefaultValues = {
        code: "",
        name: "",
        type: "",
        statuses: [] as Array<string>,
        creationDateFrom: null,
        creationDateTo: null,
        sentDateFrom: null,
        sentDateTo: null,
        reportName: "",
        invoiceNumber: "",
        sapInvoiceNumber: "",
}

export const msSinglePrintoutDefaultValues = {
        msName: "",
        msSapId: "",
        msVendorId: "",
        msVendorName: "",
        msVendorEmail: "",
        msType: "",
        type: "",
        clusterName: "",
        totalAmountFrom: "",
        totalAmountTo: "",
        sentDateFrom: null,
        sentDateTo: null,
        status: [] as Array<string>,
        invoiceNumber: "",
        sapInvoiceNumber: "",
}
